import { render, staticRenderFns } from "./StepArrow.vue?vue&type=template&id=fbb81398"
import script from "./StepArrow.ts?vue&type=script&lang=ts&external"
export * from "./StepArrow.ts?vue&type=script&lang=ts&external"
import style0 from "./StepArrow.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports